const CLIPBOARD_HTML_MARKER = 'santa-editor-clipboard';

let nativeClipboardBuffer: unknown = null;

export function getNativeClipboardBuffer(): unknown {
  return nativeClipboardBuffer;
}

export function setNativeClipboardBuffer(data: unknown): void {
  nativeClipboardBuffer = data;
}

export function clearNativeClipboardBuffer(): void {
  nativeClipboardBuffer = null;
}

export function populateClipboardEvent(event: ClipboardEvent): void {
  if (!nativeClipboardBuffer) {
    return;
  }
  const json = JSON.stringify(nativeClipboardBuffer);
  const base64 = btoa(unescape(encodeURIComponent(json)));
  event.clipboardData!.setData(
    'text/html',
    `<meta name="${CLIPBOARD_HTML_MARKER}" content="${base64}" />`,
  );
  event.clipboardData!.setData('text/plain', '');
  event.preventDefault();
}

export function readFromNativeClipboard(event: ClipboardEvent): boolean {
  const html = event.clipboardData?.getData('text/html');
  return parseClipboardHtml(html);
}

export async function writeToSystemClipboard(): Promise<void> {
  if (!nativeClipboardBuffer) {
    return;
  }
  try {
    const json = JSON.stringify(nativeClipboardBuffer);
    const base64 = btoa(unescape(encodeURIComponent(json)));
    const html = `<meta name="${CLIPBOARD_HTML_MARKER}" content="${base64}" />`;
    await navigator.clipboard.write([
      new ClipboardItem({
        'text/html': new Blob([html], { type: 'text/html' }),
        'text/plain': new Blob([''], { type: 'text/plain' }),
      }),
    ]);
  } catch {
    // clipboard-write not available or permission denied
  }
}

export async function readFromNavigatorClipboard(): Promise<boolean> {
  try {
    const items = await navigator.clipboard.read();
    for (const item of items) {
      if (item.types.includes('text/html')) {
        const blob = await item.getType('text/html');
        const html = await blob.text();
        if (parseClipboardHtml(html)) {
          return true;
        }
      }
    }
  } catch {
    // permission denied or clipboard API not available
  }
  return false;
}

function parseClipboardHtml(html: string | undefined | null): boolean {
  if (!html) {
    return false;
  }
  const regex = new RegExp(
    `name="${CLIPBOARD_HTML_MARKER}"\\s+content="([^"]+)"`,
  );
  const match = html.match(regex);
  if (!match) {
    return false;
  }
  try {
    const json = decodeURIComponent(escape(atob(match[1])));
    nativeClipboardBuffer = JSON.parse(json);
    return true;
  } catch {
    return false;
  }
}
